import { ButtonGroup, Container, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import { configServices } from '@/services';
import { FailedToGetData, Loading } from '@/components/_commons';
import { FC, useEffect, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from '@/store';
import { useDispatch } from 'react-redux';
import { useGetConfig } from '@/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
    closeModal: () => void;
};

export const ConfigRemoveCongregationModal: FC<propsType> = ({ closeModal }) => {
    const [congregation, setCongregation] = useState<{ id: number; name: string }>();
    const [congregations, setCongregations] = useState<Array<{ id: number; name: string; }>>();
    const [isLoading, setIsLoading] = useState(true);
    const config = useGetConfig();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const accept = (): void => {
        if (!congregation) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            title: '¿Eliminar Congregación?',
            message: `Se va a eliminar la Congregación ${congregation.name} (${congregation.id}) junto con todos sus datos. Esta acción es irreversible.`,
            mode: 'confirm',
            animation: 3,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await configServices.RemoveCongregation(congregation);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                if (congregation.id === config.congregation) {
                    navigate('/');
                    return;
                }
                closeModal();
            }
        }));
    }

    useEffect(() => {
        configServices.GetCongregations().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.congregations) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCongregations(response.data.congregations);
        })
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    if (!congregations) {
        return <FailedToGetData />;
    }

    return (
        <Modal
            fullscreen={'md-down'}
            onHide={closeModal}
            show
            size={'lg'}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Eliminar Congregación
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <DropdownButton
                        as={ButtonGroup}
                        className={'d-block mx-auto text-center mb-4'}
                        id={'adminsPageDropdownBtn'}
                        title={`${congregation?.name ?? 'Seleccionar'}`}
                    >
                        <Dropdown.Item eventKey={'0'}
                            onClick={() => setCongregation(undefined)}
                            active={!congregation}
                            disabled
                        >
                            Seleccionar
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        {congregations.map(c =>
                            <Dropdown.Item eventKey={c.id}
                                onClick={() => setCongregation(c)}
                                active={congregation?.id === c.id}
                            >
                                {c.name} ({c.id})
                            </Dropdown.Item>
                        )}
                    </DropdownButton>
                    <button
                        className={`btn btn-general-blue d-block w-100 mt-3`}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={accept}
                        disabled={!congregation}
                    >
                        Aceptar
                    </button>
                    <button
                        className={`btn btn-general-red d-block w-100 mt-3`}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={closeModal}
                    >
                        Cancelar
                    </button>
                </Container>
            </Modal.Body>
        </Modal>
    );
}
